import http from "../http-common";

class SettingsService {
    getAdminSettings() {
        return http.get("settings/admin");
    }
    updateSettings(data) {
        return http.put("settings/update", data);
    }
    getPublicSettings() {
        return http.get("settings/public");
    }
}

export default new SettingsService();